/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unlock_Vip_PassInputs */

const en_unlock_vip_pass = /** @type {(inputs: Unlock_Vip_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock Plus Pass`)
};

const ar_unlock_vip_pass = /** @type {(inputs: Unlock_Vip_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افتح بطاقة Plus`)
};

const de_unlock_vip_pass = /** @type {(inputs: Unlock_Vip_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freischalten Plus-Pass`)
};

const es_unlock_vip_pass = /** @type {(inputs: Unlock_Vip_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloquear Pase Plus`)
};

const fr_unlock_vip_pass = /** @type {(inputs: Unlock_Vip_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débloquez le Passe Plus`)
};

const it_unlock_vip_pass = /** @type {(inputs: Unlock_Vip_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sblocca il Pass Plus`)
};

const ja_unlock_vip_pass = /** @type {(inputs: Unlock_Vip_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusパスをアンロック`)
};

const ko_unlock_vip_pass = /** @type {(inputs: Unlock_Vip_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 패스 획득하기`)
};

const pt_br_unlock_vip_pass = /** @type {(inputs: Unlock_Vip_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloquear Passaporte Plus`)
};

const ru_unlock_vip_pass = /** @type {(inputs: Unlock_Vip_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разблокировать Plus-пропуск`)
};

const th_unlock_vip_pass = /** @type {(inputs: Unlock_Vip_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลดล็อกบัตรผ่าน Plus`)
};

const tr_unlock_vip_pass = /** @type {(inputs: Unlock_Vip_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Biletinin Kilidini Aç`)
};

const zh_cn_unlock_vip_pass = /** @type {(inputs: Unlock_Vip_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解锁 Plus 通行证`)
};

const zh_tw_unlock_vip_pass = /** @type {(inputs: Unlock_Vip_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解鎖 Plus 通行證`)
};

/**
* | output |
* | --- |
* | "Unlock Plus Pass" |
*
* @param {Unlock_Vip_PassInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const unlock_vip_pass = /** @type {((inputs?: Unlock_Vip_PassInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unlock_Vip_PassInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unlock_vip_pass(inputs)
	if (locale === "ar") return ar_unlock_vip_pass(inputs)
	if (locale === "de") return de_unlock_vip_pass(inputs)
	if (locale === "es") return es_unlock_vip_pass(inputs)
	if (locale === "fr") return fr_unlock_vip_pass(inputs)
	if (locale === "it") return it_unlock_vip_pass(inputs)
	if (locale === "ja") return ja_unlock_vip_pass(inputs)
	if (locale === "ko") return ko_unlock_vip_pass(inputs)
	if (locale === "pt_br") return pt_br_unlock_vip_pass(inputs)
	if (locale === "ru") return ru_unlock_vip_pass(inputs)
	if (locale === "th") return th_unlock_vip_pass(inputs)
	if (locale === "tr") return tr_unlock_vip_pass(inputs)
	if (locale === "zh_cn") return zh_cn_unlock_vip_pass(inputs)
	return zh_tw_unlock_vip_pass(inputs)
});